/**
 * feature-config flag names owned by workflows
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const WORKFLOWS_FLAG_NAMES = {
  BRANCH_RESTORE_ON_ADMIN: 'ff-keep-branches-on-admin-restores',
  UNAUTHENTICATED_COMMENTS: 'ff-work-928-unauthenticated-comments',
  SITE_RESTORE_DEBUG_LOGGING: 'ff-dash-4260-site-restore-logging',
  USE_CHUNKED_STREAMS: 'ff-dash-4227-use-chunked-streams',
  BRANCH_MP_OPERATIONS: 'ff-work-1170-page-branching-operations',
  VALIDATE_PUBLISH_API: 'ff-work-1917-validate-publish-api',
  OPTIMIZED_IX2_DEDUP: 'ff-work-1828-optimized-ix2-dedup',
  BRANCH_AUTOMATION: 'ff-work-1775-branch-automation',
  SITE_REDIRECT_SKIP_BACKUP: 'ff-work-1885-site-redirect-skip-backup',
  DISABLE_SITE_BACKUP_SUBMISSION: 'ff-work-1952-disable-site-backup-submission',
  DISABLE_SITE_RESTORE_SUBMISSION:
    'ff-work-1952-disable-site-restore-submission',
  SPP_DRAFT_PUBLISH: 'work-1938-spp-draft-publish',
  MULTI_USER_BRANCHING: 'ff-work-2011-multi-user-branching',
  SITE_BRANCHES: 'ff-wrkf-3428-site-branches',
  AGENTIC_WORKFLOW_CUSTOM_TRIGGERS: 'ff-aiwf-agentic-workflow-custom-triggers',
  SITE_RESTORE_BULK_VARIABLES: 'ff-work-2267-site-restore-bulk-variables',
  ENFORCE_PUBLISH_ELIGIBILITY: 'ff-work-2321-enforce-publish-eligibility',
  SKIP_UNCHANGED_SITE_ASSETS: 'ff-work-2657-skip-unchanged-site-assets',
  SQS_RECEIVE_NO_SDK_RETRY: 'ff-wrkf-4508-sqs-receive-no-sdk-retry',
  PUBLISH_LONG_RUNNING_BYPASS: 'ff-publish-long-running-bypass',
  PUBLISH_SHADOW_QUEUE: 'ff-wrkf-4364-publish-shadow-queue',
  PUBLICATION_WORKER_SHUTDOWN_DRAIN:
    'ff-wrkf-3798-publication-worker-shutdown-drain',
  PUBLISH_GLOBAL_UPLOAD_CONCURRENCY:
    'ff-work-2676-publish-global-upload-concurrency',
  NORMALIZE_COMPONENT_DIFF_OBJECT_IDS:
    'ff-work-2572-normalize-component-diff-object-ids',
  SKIP_COMPILE_TIME_HTML_GZIP: 'ff-wrkf-3670-skip-compile-time-html-gzip',
  DESIGNER_PUBLISH_FAVICON_STATUS:
    'ff-wrkf-3665-designer-publish-favicon-status',
  SITE_CREATION_TIMESTAMP_RECONCILIATION:
    'ff-wrkf-3340-site-creation-timestamp-reconciliation',
  SITE_EXPORT_STREAMING_SERIALIZATION:
    'ff-wrkf-3893-site-export-streaming-serialization',
  BUMP_STYLES_MARKER: 'ff-wrkf-3978-bump-styles-marker',
  X_ROBOTS_TAG_HEADER: 'ff-wrkf-3982-x-robots-tag-header',
  PERSIST_PUBLISH_SELECTION: 'ff-wrkf-3663-persist-publish-selection',
  CUSTOM_STAGING_SUBDOMAIN_RECONCILE:
    'ff-work-2624-custom-staging-subdomain-reconcile',
  MERGE_API_USER_PERMISSIONS: 'ff-wrkf-3941-merge-api-user-permissions',
  SCOPE_ANNOTATIONS_TO_SITE: 'ff-wrkf-4399-scope-annotations-to-site',
  IX2_EVENT_STYLES_ONLY: 'ff-wrkf-4613-ix2-event-styles-only',
  SITE_BACKUPS_API: 'ff-wrkf-4622-site-backups-api',
  DATA_API_AUTO_BACKUPS: 'ff-wrkf-4627-data-api-auto-backups',
};
